import script from "./DocumentFormDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentFormDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentFormDialog.vue?vue&type=style&index=0&id=2a69c873&lang=css"

const __exports__ = script;

export default __exports__